import {
  ParticipantFormStepState,
  participantsFormStepStore,
} from '@/scopes/checkout/infrastructure/store/participants-form-step-store'
import { identity } from 'ramda'
import { useStore } from 'zustand'

export function useParticipantsFormStepStore(
  selector: (state: ParticipantFormStepState) => any,
) {
  const store = useStore(participantsFormStepStore, identity<ParticipantFormStepState>)
  return selector(store)
}
